import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { BIGGEST_TURN_ON_COMPATIBILITY_OPTIONS } from '@/pages/Onboarding/options/BiggestTurnOnCompatibility/BIGGEST_TURN_ON_COMPATIBILITY_OPTIONS';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

export const ScreenBiggestTurnOn: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'BiggestTurnOn',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const biggestTurnOn = form.watch('biggest_turn_on');

  const handleChange = (
    option: OnbOptionType<LayoutDataType['biggest_turn_on']>,
  ) => {
    userService.createOrUpdate({
      onboarding_data: {
        biggestTurnOn: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <OnboardingPage background={'dark-solid'}>
      <OnboardingNavigation />

      <IonContent>
        <OwnAiTitle>Your biggest turn-on?</OwnAiTitle>
        <OnboardingOptionsList>
          {BIGGEST_TURN_ON_COMPATIBILITY_OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={biggestTurnOn === option.id}
              control={form.control}
              option={option}
              name="biggest_turn_on"
              key={option.id}
              onChange={() => handleChange(option)}
              TEST_ID={`biggest-turn-on-${option.id}`}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>
    </OnboardingPage>
  );
};
